import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { loadTicketTypeSuccess, loadTicketTypeFailure, updateTicketTypeSuccess, createTicketTypeSuccess, createTicketTypeFailure,
    deleteTicketTypeSuccess, deleteTicketTypeFailure,
    filterTicketUserAssignmentsSuccess, filterTicketRoleAssignmentsSuccess, filterTicketJobTitleAssignmentsSuccess,
    saveTicketUserAssignmentsSuccess, saveTicketRoleAssignmentsSuccess, saveTicketJobTitleAssignmentsSuccess
} from 'src/app/core/store/ticket-types/ticket-types.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketType, CreateTicketTypeModel, UpdateTicketTypeModel, TicketAssignmentFilterModel, TicketTypeUser, TicketTypeRole, TicketTypeJobTitle, TicketCustomField } from 'src/app/models/ticketTypeModels';
import { updateTicketType, loadTicketType, createTicketType, reorderStatuses,
     getViewTypes, filterTicketUserAssignments, filterTicketJobTitleAssignments, filterTicketRoleAssignments, 
     saveTicketUserAssignments,
     saveTicketRoleAssignments,
     saveTicketJobTitleAssignments,
     getFieldTypes,
     deleteTicketType,
     getCampusList} from 'src/app/core/store/ticket-types/ticket-types.actions';
import { State } from '../../../../core/store';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { SelectItem } from 'primeng/api';
import { getUsersList } from 'src/app/core/store/users/users.actions';
import { loadJobTitles, loadUserTypes } from 'src/app/core/store/profile/profile.actions';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MultiSelect } from 'primeng/multiselect';
import { Observable, finalize, take } from 'rxjs';

@Component({
    selector: "app-ticket-types-addit",
    templateUrl: "./ticket-types-addit.component.html",
    styleUrls: ["./ticket-types-addit.component.scss"],
    standalone: false
})
export class TicketTypeAdditComponent extends BaseComponent implements OnInit {
    @ViewChild('customFieldDescription') customFieldDescription: ElementRef;
    ticketTypeForm: FormGroup;
    isEditMode: boolean = false;
    ticketTypeId: number;
    canDeleteTypes: boolean = false;
    loadingForm: boolean = false;
    startIndex: number = 0;
    fieldStartIndex: number = 0;
    priorityStartindex: number = 0;
    showFilter: boolean = false;
    draggedItem = null;
    draggedField = null;
    draggedPriority = null;
    userFilterID: any;
    roleFilterID: any;
    titleFilterID: any;
    canBeAssignedFilter: boolean = false;
    canCreateFilter: boolean = false;
    canManageFilter: boolean = false;
    canChangeCreatedByFilter: boolean = false;
    receiveNotificationsFilter: boolean = false;
    isFiltering: boolean = false;
    inputUser: SelectItem;
    assignmentTypeRole: boolean = false;
    assignmentTypeUser: boolean = true;
    assignmentTypeTitle: boolean = false;
    updateLoading: boolean = false;
    archiveConfirmation: Observable<boolean> | null = null;
    private creatingTicketType: boolean = false;
    private pendingArchiveId: number | null = null;
    private pendingAssignmentFilter: 'User' | 'Role' | 'Title' | null = null;

    // infoModals
    showFieldNameInfo: boolean = false;
    showAutoAssignInfo: boolean = false;
    showFieldTypeInfo: boolean = false;
    showDescriptionInfo: boolean = false;
    showOtherSettingsInfo: boolean = false;
    showOnlyManagementInfo: boolean = false;
    showAssignmentInfo: boolean = false;
    showCanCreateInfo: boolean = false;
    showCanManageInfo: boolean = false;
    showOverseerInfo: boolean = false;
    showNotificationsInfo: boolean = false;
    showViewInfo: boolean = false;
    showStatusInfo: boolean = false;
    showIsDefaultInfo: boolean = false;
    showIsFinalInfo: boolean = false;
    showDeletedFields: boolean = false;
    filteredCustomFields: TicketCustomField[] = [];
    ticketType: TicketType = null;
    showPriorityInfo: boolean = false;
    showAlertTimeTypeInfo: boolean = false;
    showAlerttimeInfo: boolean = false;
    selectedActionsElement: number = -1;
    showMultiFieldInfo: boolean = false;
    selectedMultiFieldElement: string = "";

    alertTimeTypeOptions = [
        { value: 'days', label: "Days" },
        { value: 'hours', label: "Hours" },
        { value: 'minutes', label: "Minutes" },
    ];

    yesNoOptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
    ];
    colorOptions = [
        { label: 'Select', value: null },
        { label: 'Orange', value: 'orange' },
        { label: 'Aqua', value: 'aqua' },
        { label: 'Green', value: 'green' },
        { label: 'Light Blue', value: 'lightblue' },
        { label: 'Dark Blue', value: 'darkblue' },
        { label: 'Dark Yellow', value: 'yellow' },
        
    ];  
    
  usersList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  titleList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  roleList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  viewList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  fieldTypeList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  campusList: SelectItem[] = [{ label: 'loading...', value: undefined }];
  
    constructor(
        private fb: FormBuilder,
        private store: Store<State>,
        private actions$: Actions,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
    ) {
        super();
        this.ticketTypeForm = this.fb.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            color: ['', Validators.required],
            defaultEmail: [''],
            allowSendClientDocuments: [false],
            allowSendToOptoSupport: [false],
            doIncludePriority: [true],
            customFields: this.fb.array([]),
            ticketStatuses: this.fb.array([]),
            users: this.fb.array([]),
            roles: this.fb.array([]),
            jobTitles: this.fb.array([]),
            fieldTypes: this.fb.array([]),
            filteredFields: this.fb.array([]),
            priorities: this.fb.array([])
        });
    }

    ngOnInit(): void {
        this.ticketTypeId = Number(this.route.snapshot.params['id']);
        this.isEditMode = !!this.ticketTypeId;
        this.subs.push(
            this.ticketTypeForm.valueChanges.subscribe(() => this.pendingAssignmentFilter = null),
            this.store.select(s => s.ticketTypesState.loading).subscribe(loading => {
                this.loadingForm = loading
            }),
            this.store.select(s => s.ticketTypesState.saving).subscribe(saving => {
                this.updateLoading = saving;
                if (saving) {
                    this.pendingAssignmentFilter = null;
                    this.ticketTypeForm.disable({ emitEvent: false });
                }
                else this.ticketTypeForm.enable({ emitEvent: false });
            }),
            this.actions$.pipe(ofType(loadTicketTypeSuccess, updateTicketTypeSuccess, createTicketTypeSuccess))
                .subscribe(action => {
                    if (action.type === createTicketTypeSuccess.type) {
                        if (!this.creatingTicketType || this.isEditMode) return;
                        this.creatingTicketType = false;
                        this.ticketTypeId = action.ticketType.id;
                        this.isEditMode = true;
                        this.router.navigate(['/ticket-types/edit', this.ticketTypeId], { replaceUrl: true });
                    }
                    if (action.ticketType.id !== this.ticketTypeId) return;
                    this.ticketType = action.ticketType;
                    this.populateForm(action.ticketType);
                    this.ticketTypeForm.markAsPristine();
                }),
            this.actions$.pipe(ofType(createTicketTypeFailure)).subscribe(() => this.creatingTicketType = false),
            this.actions$.pipe(ofType(loadTicketTypeFailure)).subscribe(() => {
                if (this.isEditMode && !this.ticketType) this.router.navigate(['/ticket-types/list']);
            }),
            this.actions$.pipe(ofType(deleteTicketTypeSuccess)).subscribe(({ ticketType }) => {
                if (ticketType.id !== this.pendingArchiveId || ticketType.id !== this.ticketTypeId) return;
                this.pendingArchiveId = null;
                this.router.navigate(['/ticket-types/list']);
            }),
            this.actions$.pipe(ofType(deleteTicketTypeFailure)).subscribe(() => this.pendingArchiveId = null),
            this.store.select(s => s.usersState.usersList).subscribe(usersList => {
                this.usersList = usersList ? usersList.map(u => ({ label: u.firstName + ' ' + u.lastName, value: u.id }))
                    : [{ label: 'loading...', value: undefined }];
                this.usersList.unshift({ label: '', value: null });
            }),
            this.store.select(s => s.ticketTypesState.fieldTypes).subscribe(fieldTypes => {
                this.fieldTypeList = fieldTypes ? fieldTypes.map(u => ({ label: u.type, value: u.id }))
                    : [{ label: 'loading...', value: undefined }];
                this.fieldTypeList.unshift({ label: '', value: null });
            }),
            this.store.select(s => s.ticketTypesState.selectedTicketType).subscribe(selectedTicketType => {
                if (selectedTicketType?.id === this.ticketTypeId) this.ticketType = selectedTicketType;
            }),
            this.store.select(s => s.profileState.userTypes).subscribe(roleList => {
                this.roleList = roleList ? roleList.map(u => ({ label: u.userType, value: u.id }))
                    : [{ label: 'loading...', value: undefined }];
                this.roleList.unshift({ label: '', value: null });
            }),
            this.store.select(s => s.ticketTypesState.campuses).subscribe(campuses => {
                const campusesResult = campuses && campuses.length > 0 ? campuses.map(c => ({ label: c.label, value: c.value }))
                : [{ label: 'loading...', value: undefined }];

                this.campusList = campusesResult;
            }),
            this.store.select(s => s.profileState.jobTitles).subscribe(titleList => {
                this.titleList = titleList ? titleList.map(u => ({ label: u.jobTitle, value: u.id }))
                    : [{ label: 'loading...', value: undefined }];
                this.titleList.unshift({ label: '', value: null });
            }),
            this.store.select(s => s.ticketTypesState.viewTypes).subscribe(viewList => {
                this.viewList = viewList ? viewList.map(u => ({ label: u.type, value: u.id }))
                    : [{ label: 'loading...', value: undefined }];
                this.viewList.unshift({ label: '', value: null });
            }),
            this.actions$.pipe(ofType(filterTicketUserAssignmentsSuccess, saveTicketUserAssignmentsSuccess))
                .subscribe(action => {
                const { ticketTypeID, userAssignments } = action;
                if (ticketTypeID !== this.ticketTypeId) return;
                if (action.type === filterTicketUserAssignmentsSuccess.type && this.pendingAssignmentFilter !== 'User') return;
                this.pendingAssignmentFilter = null;
                this.isFiltering = true;
                this.users.clear(); // Clear existing users
                userAssignments.forEach(user => {
                    this.users.push(this.fb.group({
                        userID: [user.userID, Validators.required],
                        viewTypeID: [user.viewTypeID],
                        campusIDs: [user.campusIDs || []],
                        canBeAssigned: [user.canBeAssigned],
                        canCreateTickets: [user.canCreateTickets],
                        canManageTickets: [user.canManageTickets],
                        canChangeCreatedBy: [user.canChangeCreatedBy],
                        doSendTicketNotifications: [user.doSendTicketNotifications],
                        id: [user.id],
                        isOverseer: [user.isOverseer],
                    }));
                });
                this.isFiltering = false;
            }),
            this.actions$.pipe(ofType(filterTicketRoleAssignmentsSuccess, saveTicketRoleAssignmentsSuccess))
                .subscribe(action => {
                const { ticketTypeID, roleAssignments } = action;
                if (ticketTypeID !== this.ticketTypeId) return;
                if (action.type === filterTicketRoleAssignmentsSuccess.type && this.pendingAssignmentFilter !== 'Role') return;
                this.pendingAssignmentFilter = null;
                this.isFiltering = true;
                this.roles.clear(); // Clear existing roles
                roleAssignments.forEach(role => {
                    this.roles.push(this.fb.group({
                        roleID: [role.roleID, Validators.required],
                        viewTypeID: [role.viewTypeID],
                        canBeAssigned: [role.canBeAssigned],
                        canCreateTickets: [role.canCreateTickets],
                        canManageTickets: [role.canManageTickets],
                        canChangeCreatedBy: [role.canChangeCreatedBy],
                        doSendTicketNotifications: [role.doSendTicketNotifications],
                        id: [role.id],
                        isOverseer: [role.isOverseer],
                    }));
                });
                this.isFiltering = false;
            }),
            this.actions$.pipe(ofType(filterTicketJobTitleAssignmentsSuccess, saveTicketJobTitleAssignmentsSuccess))
                .subscribe(action => {
                const { ticketTypeID, jobTitleAssignments } = action;
                if (ticketTypeID !== this.ticketTypeId) return;
                if (action.type === filterTicketJobTitleAssignmentsSuccess.type && this.pendingAssignmentFilter !== 'Title') return;
                this.pendingAssignmentFilter = null;
                this.isFiltering = true;
                this.jobTitles.clear(); // Clear existing job titles
                jobTitleAssignments.forEach(title => {
                    this.jobTitles.push(this.fb.group({
                        jobTitleID: [title.jobTitleID, Validators.required],
                        viewTypeID: [title.viewTypeID],
                        canBeAssigned: [title.canBeAssigned],
                        canCreateTickets: [title.canCreateTickets],
                        canManageTickets: [title.canManageTickets],
                        canChangeCreatedBy: [title.canChangeCreatedBy],
                        doSendTicketNotifications: [title.doSendTicketNotifications],
                        id: [title.id],
                        isOverseer: [title.isOverseer],
                    }));
                });
                this.isFiltering = false;
            }),
        );
        this.subs.push(this.route.paramMap.subscribe(params => {
            const ticketTypeId = Number(params.get('id'));
            if (ticketTypeId !== this.ticketTypeId) {
                if (this.archiveConfirmation) this.alertService.cancelConfirmation(this.archiveConfirmation);
                this.creatingTicketType = false;
                this.pendingArchiveId = null;
            }
            this.pendingAssignmentFilter = null;
            this.ticketTypeId = ticketTypeId;
            this.isEditMode = !!this.ticketTypeId;
            if (this.isEditMode) {
                this.ticketType = null;
                this.store.dispatch(loadTicketType({ id: this.ticketTypeId }));
            }
        }));

        this.store.dispatch(getUsersList());
        this.store.dispatch(loadJobTitles());
        this.store.dispatch(loadUserTypes());
        this.store.dispatch(getFieldTypes());
        this.store.dispatch(getViewTypes());
        this.store.dispatch(getCampusList());
    }
    
    textAreaResize(e) {
        const tx = this.customFieldDescription.nativeElement;
        for (let i = 0; i < tx.length; i++) {
          tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
        }
        e.target.style.height = 0;
        e.target.style.height = (e.target.scrollHeight) + "px";
    }

  get customFields(): UntypedFormArray {
    return this.ticketTypeForm.get("customFields") as UntypedFormArray;
  }

  get ticketStatuses(): UntypedFormArray {
    return this.ticketTypeForm.get("ticketStatuses") as UntypedFormArray;
  }

  get users(): UntypedFormArray {
    return this.ticketTypeForm.get("users") as UntypedFormArray;
  }

    get priorities(): UntypedFormArray {
        return this.ticketTypeForm.get('priorities') as UntypedFormArray;
    }

  get roles(): UntypedFormArray {
    return this.ticketTypeForm.get("roles") as UntypedFormArray;
  }

  get jobTitles(): UntypedFormArray {
    return this.ticketTypeForm.get("jobTitles") as UntypedFormArray;
  }

  get fieldTypes(): UntypedFormArray {
    return this.ticketTypeForm.get("fieldTypes") as UntypedFormArray;
  }

  get filteredFields(): UntypedFormArray {
    return this.ticketTypeForm.get("filteredFields") as UntypedFormArray;
  }

  selectAssignmentType(type: string): void {
    if (type == "User") {
      this.assignmentTypeUser = true;
      this.assignmentTypeRole = false;
      this.assignmentTypeTitle = false;
    }
    if (type == "Role") {
      this.assignmentTypeUser = false;
      this.assignmentTypeRole = true;
      this.assignmentTypeTitle = false;
    }
    if (type == "Title") {
      this.assignmentTypeUser = false;
      this.assignmentTypeRole = false;
      this.assignmentTypeTitle = true;
    }
    this.pendingAssignmentFilter = null;
  }

  addCustomField(): void {
    if (this.ticketType != null && this.ticketType.customFields == null) {
      this.ticketType.customFields = [];
    }
    var length = 0;
    if (this.ticketType != null) {
      length = this.ticketType.customFields.length;
    }
    this.customFields.push(
      this.fb.group({
        name: ["", Validators.required],
        fieldTypeId: [1, Validators.required],
        fieldOptions: [""],
        allowOther: [false],
        showOnlyManagement: [false],
        description: [""],
        orderNumber: [length + 1],
        isFilter: [false],
      })
    );
  }

  removeCustomField(id: number, i: number): void {
    if (id == null) {
      this.customFields.removeAt(i);
      return;
    }
    this.customFields.at(i).patchValue({ deletedDate: new Date() });
    this.filterDeletedFields();
  }

  restoreCustomField(id: number) {
    const field = this.customFields.controls.find(x => x.get('id').value === id);
    if (field) {
      field.patchValue({ deletedDate: null });
      this.filterDeletedFields();
    }
  }

  closeMoreOptions(): void {
    this.selectedActionsElement = -1;
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  doFilter(): void {
    if (this.assignmentTypeUser) {
      this.doFilterUsers();
    } else if (this.assignmentTypeRole) {
      this.doFilterRoles();
    } else if (this.assignmentTypeTitle) {
      this.doFilterJobTitles();
    }
  }

  doFilterUsers(): void {
    if (this.updateLoading || !this.isEditMode) return;
    this.pendingAssignmentFilter = 'User';
    var filterModel: TicketAssignmentFilterModel = {
      ticketTypeID: this.ticketTypeId,
      userID: this.userFilterID != null ? this.userFilterID : null,
      roleID: null,
      titleID: null,
      canBeAssigned: this.canBeAssignedFilter,
      canCreate: this.canCreateFilter,
      canManage: this.canManageFilter,
      canChangeCreatedBy: this.canChangeCreatedByFilter,
      receiveNotifications: this.receiveNotificationsFilter,
    };

    this.store.dispatch(filterTicketUserAssignments({ filter: filterModel }));
  }

  doFilterRoles(): void {
    if (this.updateLoading || !this.isEditMode) return;
    this.pendingAssignmentFilter = 'Role';
    var filterModel: TicketAssignmentFilterModel = {
      ticketTypeID: this.ticketTypeId,
      userID: null,
      roleID: this.roleFilterID != null ? this.roleFilterID.value : null,
      titleID: null,
      canBeAssigned: this.canBeAssignedFilter,
      canCreate: this.canCreateFilter,
      canManage: this.canManageFilter,
      canChangeCreatedBy: this.canChangeCreatedByFilter,
      receiveNotifications: this.receiveNotificationsFilter,
    };

    this.store.dispatch(filterTicketRoleAssignments({ filter: filterModel }));
  }

  doFilterJobTitles(): void {
    if (this.updateLoading || !this.isEditMode) return;
    this.pendingAssignmentFilter = 'Title';
    var filterModel: TicketAssignmentFilterModel = {
      ticketTypeID: this.ticketTypeId,
      userID: null,
      roleID: null,
      titleID: this.titleFilterID != null ? this.titleFilterID.value : null,
      canBeAssigned: this.canBeAssignedFilter,
      canCreate: this.canCreateFilter,
      canManage: this.canManageFilter,
      canChangeCreatedBy: this.canChangeCreatedByFilter,
      receiveNotifications: this.receiveNotificationsFilter,
    };

    this.store.dispatch(
      filterTicketJobTitleAssignments({ filter: filterModel })
    );
  }

    clearFilter(): void {
        this.userFilterID = 0;
        this.roleFilterID = 0;
        this.titleFilterID = 0;
        this.canBeAssignedFilter = false;
        this.canCreateFilter = false;
        this.canManageFilter = false;
        this.canChangeCreatedByFilter = false;
        this.receiveNotificationsFilter = false;
        this.inputUser = {    
            label: null,
            value: null,
        };
        this.doFilter();
    }
  
    openMultiSelect(multiselect: MultiSelect) {
        multiselect.show();
    }
    setUserID(e) {
        this.userFilterID = e.value;
        if (this.userFilterID == null){
          this.userFilterID = 0;
        }
    }

  addStatus(): void {
    this.ticketStatuses.push(
      this.fb.group({
        name: ["", Validators.required],
        isFinal: [false],
        isDefault: [false],
        nextStatusIds: this.fb.array([]),
        orderNumber: [0],
      })
    );
  }

  removeStatus(index: number): void {
    this.ticketStatuses.removeAt(index);
  }

    trackByFn(index: number, item: any) {
        return index;
    }

  addPriority(): void {
    var form = this.ticketTypeForm.value
    this.priorities.push(
      this.fb.group({
        name: ["", Validators.required],
        alertTimeType: ["days"],
        priorityOrder: [form.priorities.length + 1],
        alertTime: [1],
        id: [0],
      }),
    );
  }

    removePriority(index: number): void {
        this.priorities.removeAt(index);
    }

    addUser(): void {
        this.users.insert(0, this.fb.group({
            userID: [null, Validators.required],
            viewTypeID: [null],
            canBeAssigned: [false],
            canCreateTickets: [false],
            canManageTickets: [false],
            canChangeCreatedBy: [false],
            doSendTicketNotifications: [false],
            isOverseer: [false],
            campusIDs: [[]],
        }));
    }

  addRole(): void {
    this.roles.insert(
      0,
      this.fb.group({
        roleID: [null, Validators.required],
        viewTypeID: [null],
        canBeAssigned: [false],
        canCreateTickets: [false],
        canManageTickets: [false],
        canChangeCreatedBy: [false],
        doSendTicketNotifications: [false],
        isOverseer: [false],
      })
    );
  }

  addJobTitle(): void {
    this.jobTitles.insert(
      0,
      this.fb.group({
        jobTitleID: [null, Validators.required],
        viewTypeID: [null],
        canBeAssigned: [false],
        canCreateTickets: [false],
        canManageTickets: [false],
        canChangeCreatedBy: [false],
        doSendTicketNotifications: [false],
        isOverseer: [false],
      })
    );
  }

  removeUser(index: number): void {
    this.users.removeAt(index);
  }

  removeRole(index: number): void {
    this.roles.removeAt(index);
  }

  removeJobTitle(index: number): void {
    this.jobTitles.removeAt(index);
  }

    populateForm(ticketType: TicketType): void {
        this.ticketTypeForm.patchValue({
            name: ticketType.name,
            description: ticketType.description,
            color: ticketType.color,
            defaultEmail: ticketType.defaultEmail,
            allowSendClientDocuments: ticketType.allowSendClientDocuments,
            allowSendToOptoSupport: ticketType.allowSendToOptoSupport,
            doIncludePriority: ticketType.doIncludePriority,
        });

    // Clear existing controls to avoid duplication
    this.customFields.clear();
    this.filteredCustomFields =
      this.showDeletedFields == true
        ? ticketType.customFields
        : ticketType.customFields.filter((x) => x.deletedDate == null);
    this.filteredCustomFields.forEach((field) => {
      this.customFields.push(
        this.fb.group({
          name: [field.name, Validators.required],
          fieldTypeId: [field.fieldTypeId, Validators.required],
          fieldOptions: [field.fieldOptions],
          allowOther: [field.allowOther],
          showOnlyManagement: [field.showOnlyManagement],
          id: [field.id],
          description: [field.description],
          deletedDate: [field.deletedDate],
          orderNumber: [field.orderNumber],
          isFilter: [field.isFilter],
        })
      );
    });

        this.ticketStatuses.clear();
        ticketType.ticketStatuses.forEach(status => {
            const nextStatusIds = this.fb.array(
                status.nextStatusIds.map(id => this.fb.control(id))
            );
            this.ticketStatuses.push(this.fb.group({
                name: [status.name, Validators.required],
                isFinal: [status.isFinal],
                isDefault: [status.isDefault],
                orderNumber: [status.orderNumber],
                nextStatusIds: nextStatusIds,
                id: [status.id],
            }));
        });

        const newPriorities = ticketType.priorities || [];

        newPriorities.forEach((priority, index) => {
            if (this.priorities.at(index)) {
                this.priorities.at(index).patchValue(priority);
            } else {
                this.priorities.push(this.fb.group({
                    name: [priority.name, Validators.required],
                    alertTimeType: [priority.alertTimeType],
                    alertTime: [priority.alertTime],
                    priorityOrder: [priority.priorityOrder],
                    id: [priority.id]
                }));
            }
        });

        while (this.priorities.length > newPriorities.length) {
            this.priorities.removeAt(this.priorities.length - 1);
        }
        
        this.users.clear(); // Clear existing users
        ticketType.users.forEach(user => {
            this.users.push(this.fb.group({
                userID: [user.userID, Validators.required],
                viewTypeID: [user.viewTypeID],
                campusIDs: [user.campusIDs || []],
                canBeAssigned: [user.canBeAssigned],
                canCreateTickets: [user.canCreateTickets],
                canManageTickets: [user.canManageTickets],
                canChangeCreatedBy: [user.canChangeCreatedBy],
                doSendTicketNotifications: [user.doSendTicketNotifications],
                id: [user.id],
                isOverseer: [user.isOverseer],
            }));
        });

    this.roles.clear(); // Clear existing roles
    ticketType.roles.forEach((role) => {
      this.roles.push(
        this.fb.group({
          roleID: [role.roleID, Validators.required],
          viewTypeID: [role.viewTypeID],
          canBeAssigned: [role.canBeAssigned],
          canCreateTickets: [role.canCreateTickets],
          canManageTickets: [role.canManageTickets],
          canChangeCreatedBy: [role.canChangeCreatedBy],
          doSendTicketNotifications: [role.doSendTicketNotifications],
          id: [role.id],
          isOverseer: [role.isOverseer],
        })
      );
    });

    this.jobTitles.clear(); // Clear existing job titles
    ticketType.jobTitles.forEach((title) => {
      this.jobTitles.push(
        this.fb.group({
          jobTitleID: [title.jobTitleID, Validators.required],
          viewTypeID: [title.viewTypeID],
          canBeAssigned: [title.canBeAssigned],
          canCreateTickets: [title.canCreateTickets],
          canManageTickets: [title.canManageTickets],
          canChangeCreatedBy: [title.canChangeCreatedBy],
          doSendTicketNotifications: [title.doSendTicketNotifications],
          id: [title.id],
          isOverseer: [title.isOverseer],
        })
      );
    });
  }

  onDragStart(index: number) {
    this.startIndex = index;
  }

  dragEnd() {
    this.draggedItem = null;
  }

  onDrop(event: any, dropIndex: number) {
    // add to new position
    console.log(this.startIndex + " -> " + dropIndex);
    //    this.store.dispatch(reorderStatuses({ id: this.ticketTypeId, startIndex: this.startIndex, newIndex: dropIndex }))
  }

  toggleMultiFieldInfo(name) {
    this.showMultiFieldInfo = !this.showMultiFieldInfo;
    if (this.showMultiFieldInfo) this.selectedMultiFieldElement = name;
    else this.selectedMultiFieldElement = "";
  }

  copyJsonExample() {
    const example = `[
  { 
     "title": "Field 1",
     "type": "Text" 
  },
  { 
     "title": "Field 2",
     "type": "Date" 
  },
  { 
     "title": "Field 3",
     "type": "Dynamic" 
  }
]`;
    navigator.clipboard.writeText(example);
    this.alertService.success("Example copied to clipboard");
  }

  get statuses(): UntypedFormArray {
    return this.ticketTypeForm.get("items") as UntypedFormArray;
  }

  drop(event: CdkDragDrop<UntypedFormControl[]>) {
    const formArray = this.ticketTypeForm.get("ticketStatuses") as UntypedFormArray;
    moveItemInArray(
      formArray.controls,
      event.previousIndex,
      event.currentIndex
    );
    var i = 1;
    for (var status of formArray.controls) {
      var value = status.value;
      status.setValue({
        id: value.id,
        isDefault: value.isDefault,
        isFinal: value.isFinal,
        name: value.name,
        nextStatusIds: value.nextStatusIds,
        orderNumber: i,
      });
      i++;
      console.log(status.value);
    }
  }

  onFieldDragStart(index: number) {
    this.fieldStartIndex = index;
  }

  dragFieldEnd() {
    this.draggedField = null;
  }

  dropField(event: CdkDragDrop<UntypedFormControl[]>) {
    const formArray = this.ticketTypeForm.get("customFields") as UntypedFormArray;
    moveItemInArray(
      formArray.controls,
      event.previousIndex,
      event.currentIndex
    );
    var i = 1;
    for (var field of formArray.controls) {
      var value = field.value;
      field.setValue({
        name: value.name,
        fieldTypeId: value.fieldTypeId,
        fieldOptions: value.fieldOptions,
        allowOther: value.allowOther,
        showOnlyManagement: value.showOnlyManagement,
        id: value.id,
        description: value.description,
        deletedDate: value.deletedDate,
        orderNumber: i,
        isFilter: value.isFilter,
      });
      i++;
    }
  }

    onPriorityDragStart(index: number) {
        this.priorityStartindex = index;
    }

    dragPriorityEnd() {
        this.draggedPriority = null;
    }

    dropPriority(event: CdkDragDrop<FormControl[]>) {
        const formArray = this.ticketTypeForm.get('priorities') as FormArray;
        moveItemInArray(formArray.controls, event.previousIndex, event.currentIndex);
        var i = 1;
        for (var field of formArray.controls){
            var value = field.value;
            field.setValue({
                name: value.name,
                alertTimeType: value.alertTimeType,
                alertTime: value.alertTime,
                priorityOrder: i,
                id: value.id,
            });
            i++;
        }
    }

    onDelete(): void {
        if (this.updateLoading || this.archiveConfirmation || !this.ticketType?.canDeleteTypes) return;
        const id = this.ticketType.id;
        const archived = !this.ticketType.archivedDate;
        const confirmation = this.alertService.confirm((archived ? 'Archive Ticket Type - ' : 'Unarchive Ticket Type - ') + this.ticketType.name,
            archived ? 'Archive this ticket type? Its tickets and settings will be retained, and you can restore it using Show archived ticket types.'
                : 'Unarchive this ticket type and make it available again?');
        this.archiveConfirmation = confirmation;
        this.subs.push(confirmation.pipe(take(1), finalize(() => this.archiveConfirmation = null))
              .subscribe(
                answer => {
                  if (answer && !this.updateLoading && this.ticketType?.id === id) {
                    this.pendingArchiveId = id;
                    this.store.dispatch(deleteTicketType({ id, archived }));
                  }
                }, error => {
                }
              ));
    }

    ngOnDestroy(): void {
        if (this.archiveConfirmation) this.alertService.cancelConfirmation(this.archiveConfirmation);
        super.ngOnDestroy();
    }

  onSubmit(): void {
    if (this.updateLoading || this.archiveConfirmation || (this.isEditMode && this.ticketType?.id !== this.ticketTypeId)) return;
    if (this.ticketTypeForm.valid) {
      const ticketTypeData = this.ticketTypeForm.value;
      if (ticketTypeData.customFields.length > 1 && ticketTypeData.allowSendClientDocuments == true) {
        var countClientFields = ticketTypeData.customFields.filter(
          (obj) => obj.fieldTypeId == 7 // single client field
        ).length;
        if (countClientFields == 0) {
          return this.alertService.error("Ticket Type must have a single client field in order to send client documents");
        }

      }

      if (ticketTypeData.ticketStatuses.length > 1) {
        var countDefaults = ticketTypeData.ticketStatuses.filter(
          (obj) => obj.isDefault === true
        ).length;
        if (countDefaults > 1)
          return this.alertService.error(
            "Ticket Statuses can only have one default"
          );
      }

            if (ticketTypeData.users && ticketTypeData.users.length > 0){
                var errorCheck = "The following users cannot be automatically assigned tickets because they are not overseers:  ";
                var duplicateError = "The following campuses have duplicate automatic assignments:  ";
                var hasDuplicates = false;
                var hasError = false;
                var usedCampusIDs = [];
                for (var user of ticketTypeData.users){
                    if(user.campusIDs && user.campusIDs.length > 0 && user.isOverseer == false){
                        errorCheck += this.usersList.find(u => u.value == user.userID)?.label + ",    ";
                        hasError = true;
                    }
                    else{
                        for (var program of (user.campusIDs || [])){
                            if(usedCampusIDs.findIndex(p => p == program) == -1){
                                usedCampusIDs.push(program);
                            }
                            else{
                                duplicateError += this.usersList.find(u => u.value == user.userID)?.label + " - " + this.campusList.find(p => p.value == program).label + ",   ";
                                hasDuplicates = true;
                            }
                        }
                    }
                }
                if(hasError){
                    return this.alertService.error(errorCheck);
                }
                if(hasDuplicates){
                    return this.alertService.error(duplicateError);
                }
            }

            const currentPriorities = this.ticketTypeForm.get('priorities').value;

            if (currentPriorities && currentPriorities.length > 0) {
                const invalidOnes = currentPriorities.filter(obj => 
                    obj.alertTimeType === "minutes" && Number(obj.alertTime) <= 30
                );

                if (invalidOnes.length > 0) {
                    return this.alertService.error("Priorities with an alert time type of minutes must have an alert time greater than 30");
                }
            }

            if((this.userFilterID != null && this.userFilterID > 0) ||
                (this.roleFilterID != null && this.roleFilterID > 0) ||
                (this.titleFilterID != null && this.titleFilterID > 0) ||
                this.canBeAssignedFilter || this.canCreateFilter ||
                this.canManageFilter || this.canChangeCreatedByFilter ||
                this.receiveNotificationsFilter
            ) {
                if (this.assignmentTypeUser) {
                    this.saveUsers(ticketTypeData.users);
                }
                else if (this.assignmentTypeRole) {
                    this.saveRoles(ticketTypeData.roles);
                }
                else if (this.assignmentTypeTitle) {
                    this.saveJobTitles(ticketTypeData.jobTitles);
                }
            }
            else if (this.isEditMode) {
                const updateModel: UpdateTicketTypeModel = {
                    name: ticketTypeData.name,
                    description: ticketTypeData.description,
                    color: ticketTypeData.color,
                    defaultEmail: ticketTypeData.defaultEmail,
                    allowSendClientDocuments: ticketTypeData.allowSendClientDocuments,
                    allowSendToOptoSupport: ticketTypeData.allowSendToOptoSupport,
                    doIncludePriority: ticketTypeData.doIncludePriority,
                    customFields: ticketTypeData.customFields,
                    ticketStatuses: ticketTypeData.ticketStatuses,
                    users: ticketTypeData.users,
                    roles: ticketTypeData.roles,
                    jobTitles: ticketTypeData.jobTitles,
                    priorities: ticketTypeData.priorities
                };
                this.store.dispatch(updateTicketType({ id: this.ticketTypeId, ticketType: updateModel }));
            } else {
                const createModel: CreateTicketTypeModel = {
                    name: ticketTypeData.name,
                    description: ticketTypeData.description,
                    color: ticketTypeData.color,
                    defaultEmail: ticketTypeData.defaultEmail,
                    allowSendClientDocuments: ticketTypeData.allowSendClientDocuments,
                    allowSendToOptoSupport: ticketTypeData.allowSendToOptoSupport,
                    doIncludePriority: ticketTypeData.doIncludePriority,
                    customFields: ticketTypeData.customFields,
                    ticketStatuses: ticketTypeData.ticketStatuses,
                    users: ticketTypeData.users,
                    roles: ticketTypeData.roles,
                    jobTitles: ticketTypeData.jobTitles,
                    priorities: ticketTypeData.priorities
                };
                this.creatingTicketType = true;
                this.store.dispatch(createTicketType({ ticketType: createModel }));
            }

        }
    }

  saveUsers(users: TicketTypeUser[]): void {
    this.store.dispatch(saveTicketUserAssignments({ ticketTypeID: this.ticketTypeId, users }));
  }

  saveRoles(roles: TicketTypeRole[]): void {
    this.store.dispatch(saveTicketRoleAssignments({ ticketTypeID: this.ticketTypeId, roles }));
  }

  saveJobTitles(jobTitles: TicketTypeJobTitle[]): void {
    this.store.dispatch(saveTicketJobTitleAssignments({ ticketTypeID: this.ticketTypeId, jobTitles }));
  }

  doToggleDeletedCustomFields() {
    this.filterDeletedFields();
  }

  filterDeletedFields() {
    if (this.ticketType == null) {
      return;
    }
    const drafts = this.customFields.getRawValue();
    this.ticketType = {
      ...this.ticketType,
      customFields: [
        ...this.ticketType.customFields.filter(field => field.id != null && !drafts.some(draft => draft.id === field.id)),
        ...drafts,
      ],
    };
    this.customFields.clear();
    this.filteredCustomFields =
      this.showDeletedFields == true
        ? this.ticketType.customFields
        : this.ticketType.customFields.filter((x) => x.deletedDate == null);
    this.filteredCustomFields.forEach((field) => {
      this.customFields.push(
        this.fb.group({
          name: [field.name, Validators.required],
          fieldTypeId: [field.fieldTypeId, Validators.required],
          fieldOptions: [field.fieldOptions],
          allowOther: [field.allowOther],
          showOnlyManagement: [field.showOnlyManagement],
          id: [field.id],
          description: [field.description],
          deletedDate: [field.deletedDate],
          orderNumber: [field.orderNumber],
          isFilter: [field.isFilter],
        })
      );
    });
  }

    doToggleAlertTimeTypeInfo(){
        this.showAlertTimeTypeInfo = !this.showAlertTimeTypeInfo;
    }

    doToggleAlertTimeInfo(){
        this.showAlerttimeInfo = !this.showAlerttimeInfo;
    }

    doToggleFieldNameInfo(){
        this.showFieldNameInfo = !this.showFieldNameInfo;
    }

    doToggleAutoAssignInfo(){
        this.showAutoAssignInfo = !this.showAutoAssignInfo;
    }

    doToggleFieldTypeInfo(){
        this.showFieldTypeInfo = !this.showFieldTypeInfo;
    }
    
    doToggleDescriptionInfo(){
        this.showDescriptionInfo = !this.showDescriptionInfo;
    }
    
    doToggleOtherSetttingsInfo(){
        this.showOtherSettingsInfo = !this.showOtherSettingsInfo;
    }
    
    doToggleOnlyManagementInfo(){
        this.showOnlyManagementInfo = !this.showOnlyManagementInfo;
    }

  doToggleAssignmentInfo() {
    this.showAssignmentInfo = !this.showAssignmentInfo;
  }
  doToggleCanCreateInfo() {
    this.showCanCreateInfo = !this.showCanCreateInfo;
  }
  doToggleCanManageInfo() {
    this.showCanManageInfo = !this.showCanManageInfo;
  }
  doToggleOverseerInfo() {
    this.showOverseerInfo = !this.showOverseerInfo;
  }
  doToggleNotificationsInfo() {
    this.showNotificationsInfo = !this.showNotificationsInfo;
  }
  doToggleViewInfo() {
    this.showViewInfo = !this.showViewInfo;
  }
  doToggleStatusInfo() {
    this.showStatusInfo = !this.showStatusInfo;
  }
  doToggleIsFinalInfo() {
    this.showIsFinalInfo = !this.showIsFinalInfo;
  }
  doToggleIsDefaultInfo() {
    this.showIsDefaultInfo = !this.showIsDefaultInfo;
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  selectCustomFieldActions(index, event) {
    event.stopPropagation();
    if (this.selectedActionsElement == index) this.selectedActionsElement = -1;
    else this.selectedActionsElement = index;
  }
  doShowActions(index) {
    return this.selectedActionsElement == index;
  }
}
